// src/ai/smart/smartNotifications.js
// Minimal "smart notifications" builder. For now it only emits an alert when local changes are unsent.

export function readDirtyFlag() {
  if (typeof window === "undefined") return false;
  try {
    return window.localStorage.getItem("mudo:dirty") === "1";
  } catch {
    return false;
  }
}

export function buildSmartNotifications(context = {}) {
  const notifications = [];
  const hasUnsyncedChanges =
    typeof context.hasUnsyncedChanges === "boolean" ? context.hasUnsyncedChanges : readDirtyFlag();

  if (hasUnsyncedChanges) {
    notifications.push({
      id: "smart-unsynced-changes",
      type: "sync",
      severity: "warning",
      message: "You have unsent updates. Tap Send to sync your latest studio changes.",
      link: { section: "sync" },
      source: "smart",
    });
  }

  return notifications;
}
